export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14072.02685946.jpg";